import { render, staticRenderFns } from "./MyLicenseDialog.vue?vue&type=template&id=60a15b72&scoped=true"
import script from "./MyLicenseDialog.vue?vue&type=script&lang=js"
export * from "./MyLicenseDialog.vue?vue&type=script&lang=js"
import style0 from "./MyLicenseDialog.vue?vue&type=style&index=0&id=60a15b72&prod&lang=scss&scoped=true"
import style1 from "./MyLicenseDialog.vue?vue&type=style&index=1&id=60a15b72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a15b72",
  null
  
)

export default component.exports